/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Sidebar_AccountInputs */

const en_layout_sidebar_account = /** @type {(inputs: Layout_Sidebar_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pl_layout_sidebar_account = /** @type {(inputs: Layout_Sidebar_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Layout_Sidebar_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_sidebar_account = /** @type {((inputs?: Layout_Sidebar_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Sidebar_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_sidebar_account(inputs)
	return en_layout_sidebar_account(inputs)
});